import React from "react";
import FAQAccordion from '../FAQAccordion';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section id="info-colorado-river" className="about-us pt-trip gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div>
                <div className="section-heading mb-5 mx-2">
                  {this.props.showTitle && this.props.showTitle === true && (
                    <title className="badge badge-primary badge-pill">
                      How to Use Hiking Poles Correctly?
                    </title>
                  )}
                  <h1 className="text-center">
                    How to Use Hiking Poles Correctly (Complete Beginner Guide)<br />
                  </h1>
                <p>Hiking poles might look simple, but using them correctly can completely change how you hike. They reduce strain on your knees, improve balance on uneven terrain, and help you hike longer with less fatigue.</p>
<p>If you hike in places like <a class="in-text-link" href="https://exploroff.com/chain-lakes-loop">Chain Lakes Loop</a>, trekking poles become incredibly useful on steep climbs, rocky trails, and snowy sections.</p>
<p>This guide explains how to use hiking poles correctly, from adjusting them to proper technique for uphill and downhill hiking.</p>
                  <FAQAccordion
                    title="How to Use Hiking Poles FAQs"
                    items={[
                      { q: 'How do you adjust the height of hiking poles?', a: 'Your elbow should be at a 90-degree angle when holding the grip with the tip on the ground. For uphill, shorten by 5–10cm. For downhill, lengthen by 5–10cm. Most poles adjust with a twist lock or lever lock mechanism.' },
                      { q: 'Should you use one or two hiking poles?', a: 'Two poles provide the most benefit — better balance, more even weight distribution, and greater stability on technical terrain. One pole is a compromise but still helps on moderate trails.' },
                      { q: 'How do you hold hiking poles correctly?', a: 'Thread your hand up through the wrist strap from below, then grip the handle lightly. The strap should carry most of the downward force, not your grip. A tight grip leads to hand fatigue.' },
                      { q: 'Do hiking poles really help your knees?', a: 'Yes — studies show hiking poles reduce the load on your knee joints by up to 25% on descents. They are especially valuable if you have knee pain or are carrying a heavy pack.' },
                      { q: 'What type of hiking pole tip is best?', a: 'Carbide tips work on most hard surfaces. Use rubber tip covers on pavement or in huts to protect floors. For snow and soft ground, attach a larger basket to prevent the pole from sinking in.' },
                      { q: 'When should you not use hiking poles?', a: 'Poles can interfere with scrambling, climbing, or using your hands on very technical terrain. Collapse them and attach to your pack for these sections.' },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default About;